import { useState } from 'react'

export function useSitePhoto(siteId: string) {
  const [hasFallback, setHasFallback] = useState(false)
  const [prevSiteId, setPrevSiteId] = useState(siteId)
  if (prevSiteId !== siteId) {
    setPrevSiteId(siteId)
    setHasFallback(false)
  }
  return {
    src: `/photos/${siteId}.jpg`,
    hasFallback,
    onError: () => setHasFallback(true),
  }
}
